import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSurguryConsultationPage } from "reduxx/actions/pages/surguryConsultation";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { SURGURY_CONSULTATION } from 'apis'; 
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import LogoBlack512 from 'styles/images/logo/logo512-black.png';
import actionStyles from 'styles/css/ActionStyles.module.scss';

const SurgeryConsultation = () => {

    const { t } = useTranslation();
    const { i18n } = useTranslation();

    const { lng } = useParams();

    const dispatch = useDispatch();

    const { inputFullname, inputMobile, inputEmail, inputComment } = useSelector(state => state.surguryConsultation);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        
        if(name === 'inputComment' && value.length > 700)
            return;

        if(name === 'inputMobile')
            dispatch(handleChangeDataSurguryConsultationPage(name, changeNumberPersianAndArabic(value)));
        else 
            dispatch(handleChangeDataSurguryConsultationPage(name, value));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    const handleSubmitForm = (event) => {
        event.preventDefault();

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputComment.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'متن نظر را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: SURGURY_CONSULTATION,
                    method: 'post',
                    data: { mobile: inputMobile, fullname: inputFullname, email: inputEmail, comment: inputComment },
                    token: null,
                    successMessage: null,
                    onSuccess: (res) => {
                        dispatch(handleChangeDataSurguryConsultationPage('inputMobile', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputFullname', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputEmail', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputComment', ''));
                        // navigate(`verify`);

                        const buttonsOkCancel = Swal.mixin({
                            customClass: {
                                // confirmButton: actionStyles['btn-accept'],
                                confirmButton: [actionStyles['btn-cancel'], ].join(' '),
                                cancelButton: [actionStyles['btn-cancel'], actionStyles['mr-12']].join(' '),
                            },
                            buttonsStyling: false
                        });

                        buttonsOkCancel.fire({
                            text: t("success_reg_consultation_msg"),
                            imageUrl: LogoBlack512,
                            imageHeight: 80,
                            imageAlt: 'stone',
                            confirmButtonText: t("ok"),
                            showCancelButton: false,
                        }).then((result) => {
                            
                        }); 
                    },
                });
            }

        }
    };

    const toPersianDigits = (num) => {
        if(lng === "ar")
            return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
        else
            return num;
    };

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                

                





                <div className={[formStyles.formBox, sharedStyles['!mt-[24px]']].join(' ')}>
                    <div className={[formStyles.title, formStyles['text-center'], sharedStyles['card-text']].join(' ')}>
                        {t("consult_form_title")}
                    </div>

                    <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={[formStyles.input, sharedStyles['mt-[16px]']].join(' ')} placeholder={t("name")} />
                    <input type="email" name="inputEmail" value={inputEmail} onChange={handleChangeInputs} className={formStyles.input} placeholder={t("email_optional")} />
                    <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder={t("phone_whatsapp")} dir={i18n.dir()}  />
                    <textarea rows={5} name="inputComment" value={inputComment} onChange={handleChangeInputs} className={formStyles.input} placeholder={t("message")} style={{marginBottom: '0'}} />
                    <span>{toPersianDigits(inputComment.length)}/{toPersianDigits(700)}</span>
                    <button onClick={handleSubmitForm} className={[formStyles.button, sharedStyles['!mt-[24px]']].join(' ')}>{t("send")}</button>
                </div>


            </div>
                
        </div>

    );
}

export default SurgeryConsultation;